<div class="toolbar-wrap">
  <div class="toolbar">
    <h2 class="toolbar-title">{{ title | translate }}</h2>
    <div class="toolbar-actions">
      <ng-content></ng-content>
    </div>
  </div>
</div>
